/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Audio_Description_Export_Status_Creating_SegmentInputs */



/**
* | output |
* | --- |
* | "Creating segment {current}/{total}..." |
*
* @param {Audio_Description_Export_Status_Creating_SegmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_creating_segment = /** @type {((inputs: Audio_Description_Export_Status_Creating_SegmentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Creating_SegmentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Création du segment ${i?.current}/${i?.total}...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Erstelle Segment ${i?.current}/${i?.total}...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Creazione del segmento ${i?.current}/${i?.total}...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Создание сегмента ${i?.current}/${i?.total}...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Creando el segmento ${i?.current}/${i?.total}...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`创建段 ${i?.current}/${i?.total}...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`セグメント ${i?.current}/${i?.total} を作成しています...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सेगमेंट ${i?.current}/${i?.total} बनाया जा रहा है...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Criando segmento ${i?.current}/${i?.total}...`)
	return /** @type {LocalizedString} */ (`Creating segment ${i?.current}/${i?.total}...`)
});